export enum CopType {
	BUILDER = 'builder',
	CUBE_CAMERA = 'cubeCamera',
	VIDEO = 'video',
	WEB_CAM = 'webCam',
	SNAPSHOT = 'snapshot',
}

export enum CopTypeImage {
	IMAGE = 'image',
	IMAGE_EXR = 'imageEXR',
	IMAGE_HDR = 'imageHDR',
	IMAGE_KTX2 = 'imageKTX2',
}
